// extracted by mini-css-extract-plugin
module.exports = {"notFoundChip":"aA"};